module.exports = {"411727001":"汝宁街道","411727002":"三门闸街道","411727003":"古塔街道","411727004":"宿鸭湖街道","411727101":"王岗镇","411727102":"梁祝镇","411727103":"和孝镇","411727104":"老君庙镇","411727105":"留盆镇","411727106":"金铺镇","411727107":"东官庄镇","411727108":"常兴镇","411727109":"罗店镇","411727110":"韩庄镇","411727111":"三桥镇","411727112":"张楼镇","411727204":"南余店乡","411727212":"板店乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411727.json
// module id = 1816
// module chunks = 0